/**
 * Paleta de colores de la vista de preinforme.
 * Centraliza los hex de la maqueta (harness/spec/5-refactror-informe/template.html)
 * y la escala de severidad del payload del servicio, para no hardcodear colores
 * en los componentes.
 */

export const PREINFORME_COLORS = {
	// Azul principal de la maqueta (botones, acentos)
	blue: "#0056a4",
	// Azul de hover del botón principal
	blueHover: "#004382",
	// Azul claro de fondo (resaltados suaves)
	blueLight: "#ebf4ff",
	// Rojo de alerta / severidad grave
	red: "#e31b23",
	// Texto oscuro principal
	dark: "#0f172a",
	// Verde azulado de acentos secundarios
	teal: "#0d9488",
	// Fondo de superficie de las tarjetas
	surface: "#ffffff",
	// Borde neutro de las tarjetas
	border: "#e2e8f0",
	// Texto secundario / atenuado
	textMuted: "#64748b",
	// Azul oscuro del degradado del panel de metas a 12 semanas (inicio)
	darkPanelStart: "#0a1e38",
	// Azul oscuro del degradado del panel de metas a 12 semanas (medio)
	darkPanelMid: "#003366",
	// Azul oscuro del degradado del panel de metas a 12 semanas (fin)
	darkPanelEnd: "#0f2a4a",
	// Cian claro de las etiquetas del panel de metas a 12 semanas
	cyanLight: "#67e8f9",
	// Fondo ámbar suave del aviso de advertencias
	warningBg: "#fef3c7",

	// Escala de severidad de payload.metricas[].severidad (0 = óptimo, 3 = grave).
	// No confundir con la escala de HelpUserMachine.js/selectIconIes: ese mapeo
	// usa 0 = "Sin Registro" (gris), que aquí significaría lo contrario.
	severidad: {
		0: "#10b981", // óptimo / normal
		1: "#fbbf24", // desviación leve
		2: "#f59e0b", // advertencia
		3: "#e31b23", // grave
		neutro: "#94a3b8", // severidad desconocida o no aplica
	},
};

export default PREINFORME_COLORS;
